import { render, staticRenderFns } from "./wb-header.vue?vue&type=template&id=25aa92c4&scoped=true"
import script from "./wb-header.vue?vue&type=script&lang=js"
export * from "./wb-header.vue?vue&type=script&lang=js"
import style0 from "./wb-header.vue?vue&type=style&index=0&id=25aa92c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25aa92c4",
  null
  
)

export default component.exports